module.exports = __webpack_public_path__ + "media/direct_cabinet_n3.334353f7.wav";